export enum AddMemberWizardPageContainersKeys {
  LeftContainer = 'left-container',
  RightContainer = 'right-container',
}
